import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.view.modal("VoiceFormModal", {

    initialize: function(options) {
      this.size = "large";
      this.editable = _.isUndefined(options.editable) ? true : options.editable;
      this.tempModel = new app.Models.VoiceKeyword();
      if (this.model.toJSON().phrase_array.length) {
        this.tempModel.set(this.tempModel.parse(this.model.toJSON()));
      } else {
        this.tempModel.setDefaultState();
      }

      _.bindAll(this, "_update");
    },

    title: function() {
      return "Spoken Phrases";
    },

    body: function() {
      return new app.Views.VoiceForm({ model: this.tempModel, isModal: true, editable: this.editable }).render();
    },

    close: function() {
      app.Views.VoiceFormModal.__super__.close.apply(this, arguments);
    },

    _update: function() {
      this.model.set(this.model.parse(this.tempModel.toJSON()));

      this.trigger('save');
      this.model.trigger('sync');
    },

    buttons: function() {
      var self = this;

      if (this.editable) {
        return [
          {
            text: "Cancel",
            className: "btn-secondary",
            close: true
          },
          {
            text: "Done",
            className: "btn-primary",
            click: function(e) {
              if (self.tempModel.isValid()) {
                self.setError(null);
                self._update();
                self.close();
              } else {
                self.setError(self.tempModel.errorMessages());
              }

              return false;
            }
          }
        ];
      } else {
        return [
          {
            text: "Done",
            className: "btn-primary",
            click: function(e) {
              self.close();

              return false;
            }
          }
        ];
      }
    }
  });
});
